/**
 * Funciones puras para interpretar los atributos administrativos del usuario
 * que devuelve `GET /v2/usuarios/atributos`.
 */

const tieneAtributo = (atributos, nombre) => atributos.find((attr) => attr?.atributo === nombre)?.valor === 'S'

const esListaValida = (atributos) => Array.isArray(atributos) && atributos.length > 0

/**
 * Extrae el rol del usuario desde los atributos administrativos
 * @param {Array} atributos - Lista de atributos del usuario
 * @returns {string} Rol del usuario
 */
export const getRolFromAtributos = (atributos) => {
  if (!esListaValida(atributos)) return ''

  if (tieneAtributo(atributos, 'ADMINTOTAL')) return 'Administrador de Provincia ART'
  if (tieneAtributo(atributos, 'ADMINEMPRESA')) return 'Administrador'
  if (tieneAtributo(atributos, 'ADMINHYS')) return 'HYS'

  return ''
}

/**
 * @param {Array} atributos
 * @returns {boolean} true si es Admin ART o administrador de la empresa
 */
export const esUsuarioAdmin = (atributos) => {
  if (!esListaValida(atributos)) return false
  return tieneAtributo(atributos, 'ADMINTOTAL') || tieneAtributo(atributos, 'ADMINEMPRESA')
}

/**
 * @param {Array} atributos
 * @returns {boolean} true si es Admin ART o Admin HyS: pueden operar sobre cualquier contrato
 */
export const esUsuarioAdminARToHyS = (atributos) => {
  if (!esListaValida(atributos)) return false
  return tieneAtributo(atributos, 'ADMINTOTAL') || tieneAtributo(atributos, 'ADMINHYS')
}
